'use client';
import { HomePageSkeleton } from '@/_components/skeletons';
export default function Loading() {
    return <HomePageSkeleton />;
}
